<template>
  <div>
    <div v-show="emsl == 0">
      <!-- 骨架屏 -->
      <skeleton-screen v-show="!dataLoaded"></skeleton-screen>
      <div v-if="dataLoaded" class=" col-md-12 col-sm-12 col-lg-12 col-xl-12  pl-0 pr-0 ml-0 pr-0 lieb scroll-container sjbtop mb-4" style="width: calc(100% - 1vw)" ref="scrollContainer">
        <div v-if="show == 0" style="width: 100%;" id="zhixingld">
          <div class="sjyinc" style="width: 100%;">
            <div style="width: 100%;position: relative;">
              <div @click="fczff()" class="position-absolute curpo" style="z-index: 9; color: white;left: 7%;top: 13%;width: 93%;">
                <div class="col-md-5 pl-0 pr-0 mb-1" style="font-size: calc(10px + 0.4vw);">{{
									hot.small_title }}
                </div>
                <div class="mb-2 col-md-5 pl-0 pr-0 sjbxzt" style="font-size: calc(15px + 0.4vw);font-weight: 700;">{{ hot.title }}</div>
                <div class="col-md-5 pl-0 pr-0 sjbzt" style="font-size: calc(8px + 0.4vw);font-weight: 500;">{{ hot.sub_title }}</div>
                <div class="ckqbb yuanjiao pt-2 pb-2 mt-1 sjbxzt" style="width: 25%;background-color: #FFD672;text-align: center;font-size: calc(7px + 0.4vw);color: #000;">
                  <!-- {{ $t('查看详情') }} -->
                  立即支持
                </div>
              </div>
              <!-- <img @click="fczff()" class="col-sm-12 pl-0 pr-0 curpo"
								src="@/img/details/pic_jkhd_banner@2x.png"
								style="border: 1px solid pink; width: 100%;min-height: 200px;" alt="" /> -->
              <div class="curpo" style="width: 100%;">

                <img @click="fczff()" class=" curpo yuanjiao" :src="hot.image" style=" width: 100%;height: 20vh;object-fit: cover;" alt="" />

              </div>

              <div class=" mt-3 d-flex pl-0 pr-0 justify-content-around align-items-center" style="width: 100%;">
                <div class=" pl-0 pr-0 " style="width: 32%;">
                  <div class="yuanjiao baise p-2">
                    <div class="d-flex align-items-center mb-1">
                      <div class="mr-1"><img style="width: calc(15px + 0.5vw);" src="@/img/icon_leijijuankuan@2x.png" alt="" /></div>
                      <div class="" style="font-size: calc(9px + 0.4vw);font-weight: 500;">{{ $t('纍計捐款金額') }}</div>
                    </div>
                    <div style="font-size: calc(11px + 0.4vw);font-weight: 600;text-align: center;">
                      {{ xasddinfo.received_amount ? xasddinfo.received_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                    </div>
                  </div>
                </div>
                <div class=" pl-0 pr-0 " style="width: 32%;">
                  <div class="yuanjiao baise p-2">
                    <div class="d-flex align-items-center mb-1">
                      <div class="mr-1"><img style="width: calc(15px + 0.5vw);" src="@/img/icon_yijingjuankuan@2x.png" alt="" /></div>
                      <div class="" style="font-size: calc(9px + 0.4vw);font-weight: 500;">{{ $t('已使用捐款金額') }}</div>
                    </div>
                    <div style="font-size: calc(11px + 0.4vw);font-weight: 600;text-align: center;">
                      {{ xasddinfo.used_amount ? xasddinfo.used_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                    </div>
                  </div>
                </div>
                <div class=" pl-0 pr-0 " style="width: 32%;">
                  <div class="yuanjiao baise p-2">
                    <div class="d-flex align-items-center mb-1">
                      <div class="mr-1"><img style="width: calc(15px + 0.5vw);" src="@/img/icon_leijirenci@2x.png" alt="" /></div>
                      <div class="" style="font-size: calc(9px + 0.4vw);font-weight: 500;">{{ $t('纍計捐款人次') }}</div>
                    </div>
                    <div style="font-size: calc(11px + 0.4vw);font-weight: 600;text-align: center;">
                      {{ xasddinfo.donor_num ? xasddinfo.donor_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="yinc col-sm-12 pl-0 pr-0 d-flex justify-content-between">
            <div class="col-md-12 col-sm-12 col-xl-9 pl-0 pr-0">
              <div class="col-md-12 pl-0 pr-0">
                <div @click="fczff()" class=" pl-0 pr-0 position-absolute curpo" style="z-index: 99; color: white;left: 7%;top: 13%;width: 93%;">
                  <div class="col-md-5 pl-0 pr-0 mb-2" style="font-size: calc(10px + 0.4vw);">{{
									hot.small_title }}
                  </div>
                  <div class="mb-2 col-md-5 pl-0 pr-0" style="font-size: calc(22px + 0.4vw);font-weight: 700;">{{ hot.title }}</div>
                  <div class="col-md-5 pl-0 pr-0" style="font-size: calc(15px + 0.4vw);font-weight: 500;">{{ hot.sub_title }}</div>
                  <div class="col-sm-2 pl-0 pr-0 ckqbb yuanjiao pt-3 pb-3 mt-5" style="background-color: #FFD672;text-align: center;font-size: calc(7px + 0.4vw);color: #000;">
                    <!-- {{ $t('查看详情') }} -->
                      立即支持
                  </div>
                </div>
                <div class="col-sm-12 pl-0 pr-0 curpo" style="">
                  <img @click="fczff()" class=" curpo yuanjiao" :src="hot.image" style=" width: 100%;height: 326px;object-fit: cover;" alt="" />
                </div>
                <div class=" mt-3 d-flex pl-0 pr-0 justify-content-around align-items-center" style="width: 100%;">
                  <div class=" pl-0 pr-0 " style="width: 32%;">
                    <div class="yuanjiao baise p-3 d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <div class="mr-2"><img style="width: calc(15px + 0.5vw);" src="@/img/icon_leijijuankuan@2x.png" alt="" /></div>
                        <div class="sjbzt" style="font-size: calc(10px + 0.4vw);font-weight: 500;">{{ $t('纍計捐款金額') }}</div>
                      </div>
                      <div style="font-size: calc(10px + 0.4vw);font-weight: 600;">
                        {{ xasddinfo.received_amount ? xasddinfo.received_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                      </div>
                    </div>
                  </div>
                  <div class=" pl-0 pr-0 " style="width: 32%;">
                    <div class="yuanjiao baise p-3 d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <div class="mr-2"><img style="width: calc(15px + 0.5vw);" src="@/img/icon_yijingjuankuan@2x.png" alt="" /></div>
                        <div class="sjbzt" style="font-size: calc(10px + 0.4vw);font-weight: 500;">{{ $t('已使用捐款金額') }}</div>
                      </div>
                      <div style="font-size: calc(10px + 0.4vw);font-weight: 600;">
                        {{ xasddinfo.used_amount ? xasddinfo.used_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                      </div>
                    </div>
                  </div>
                  <div class=" pl-0 pr-0 " style="width: 32%;">
                    <div class="yuanjiao baise p-3 d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <div class="mr-2"><img style="width: calc(15px + 0.5vw);" src="@/img/icon_leijirenci@2x.png" alt="" /></div>
                        <div class="sjbzt" style="font-size: calc(10px + 0.4vw);font-weight: 500;">{{ $t('纍計捐款人次') }}</div>
                      </div>
                      <div style="font-size: calc(10px + 0.4vw);font-weight: 600;">
                        {{ xasddinfo.donor_num ? xasddinfo.donor_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="yuanjiao col-xl-3 yinc ml-0 pr-0 phoneNone leftSidebarBox" ref="leftSidebarBox" style="position: fixed;right: 1.8vw;flex:1;max-width:20vw;top:9vh;max-height: 86.5vh;overflow-y: auto;">
              <div class="baise col-md-12 pb-2 yuanjiao pl-0 pr-0" style="height: 86.5vh;">
                <div class="mb-2 d-flex justify-content-between ml-3 mr-3 pt-3" style="font-size: calc(8px + 0.4vw); font-weight: 500">
                  <div>{{ $t("资金用途") }}</div>
                  <!-- <div class="ckq curpo" style="color: #ffd672">
                    {{ $t("查看全部") }}
                  </div> -->
                </div>
                <div class="mb-2 ml-3 mr-3 col-md-11" style="height: 1px; background: #e5e5e5"></div>
                <div v-show="index <= 4" @click="zjsyqk(item.donation_id)" v-for="(item, index) in used" :key="index" class="d-flex  justify-content-between ckqbb curpo align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2 yuanjiao">
                  <div class="d-flex justify-content-between align-items-center">
                    <img class="mr-2" style="width: calc(35px + 0.5vw);height: calc(35px + 0.4vw);border-radius: 50%;object-fit: cover;" :src="item.donation_image" alt="" />
                    <div>
                      <div class="ellipsis" style="font-size: calc(7px + 0.4vw); white-space: nowrap; overflow: hidden;text-overflow: ellipsis;max-width: 11vw;">
                        {{ item.donation_name }}
                      </div>
                      <div class="d-flex align-items-center mt-1">
                        <div class="d-flex mr-2 align-items-center" style="font-size: calc(6px + 0.4vw);color: #666666;">
                          <img style="width: calc(7px + 0.5vw);height: calc(7px + 0.5vw);" src="@/img/daohangl/icon_jkhd_qian@2x.png" alt="" />
                          <div class="ml-1">{{ item.amount ? item.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
                        </div>
                        <div class="d-flex mr-3 align-items-center" style="font-size: calc(6px + 0.4vw); color: #666666">
                          <img style="
                          width: calc(7px + 0.5vw);
                          height: calc(7px + 0.5vw);
                        " src="@/img/icon_jkhd_shijain@2x.png" alt="" />
                          <div class="ml-1">{{ timeFilter(item.create_time) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img style="width: calc(15px + 0.5vw)" src="@/img/daohangl/icon_hssy_hdlb_xiangqing@2x.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <juank ref="fczdf" @custom='custom' @emslfun='emslfun' :allList="donation" :ids="isids"></juank>
        <b-modal v-model="modalShow" modal-class="custom-modal-widths" :centered="true" hide-header hide-footer>
          <div style="width: 100%;" class="p-2">
            <div class="d-flex p-0" style="width: 100%;justify-content: space-between;">
              <div class="tkd">{{ $t("计费对象:") }}</div>
              <div class="tkd" style="margin-right: 4px;">{{ $t("订单号:") }}</div>
            </div>
            <div class="d-flex p-0 mt-2" style="width: 100%;justify-content: space-between;">
              <div class="tkd">{{ tkdsj.name }}</div>
              <div class="tkx">{{ tkdsj.order_no }}</div>
            </div>
            <div class="d-flex p-0 mt-2" style="width: 100%;justify-content: space-between;align-items: center;">
              <div>
                <div class="tkx" style="text-align: left">{{ $t("地址：") }}{{ tkdsj.address }}</div>
                <div class="tkx mt-2" style="text-align: left">Email：{{ tkdsj.email }}</div>
                <div class="tkx mt-2">{{ $t("手机号码：") }}{{ tkdsj.phone }}</div>
              </div>
              <div>
                <div class="tkd" style="text-align: right;margin-right: 4px">{{ $t("发票日期:") }}</div>
                <div class="tkx mt-2" style="text-align: right">{{ timeFilter(tkdsj.pay_time) }}</div>
              </div>
            </div>
            <div class="mt-4 tkd">{{ $t("订单摘要") }}</div>
            <div class="mt-2 d-flex" style="width: 100%;">
              <div class="xiaod" style="width: 30%;">{{ $t("项目") }}</div>
              <div class="xiaod" style="width: 30%;">{{ $t("金额") }}</div>
              <div class="xiaod" style="width: 20%;">{{ $t("期数") }}</div>
              <div class="xiaod" style="text-align: right;width: 20%;">{{ $t("总额") }}</div>
            </div>
            <div class="bdxian mt-2 mb-2"></div>
            <div class="d-flex" style="width: 100%;">
              <div class="tkx" style="width: 30%;">{{ tkdsj.donation_name }}</div>
              <div class="tkx" style="width: 30%;">NT$ {{ tkdsj.installment_amount }}</div>
              <div class="tkx" style="width: 20%;">{{ tkdsj.period }}</div>
              <div class="tkx" style="text-align: right;width: 20%;">NT$ {{ tkdsj.amount }}</div>
            </div>
            <div class="mt-4" style="text-align: right;">
              <span @click="modalShow=false" class="curpo ckqbb pt-2 pb-2 pr-5 pl-5 yuanjiao" style="font-size: calc(8px + 0.4vw);background:#FFD672;">{{ $t("关闭") }}</span>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div v-if="showImage" class="curpo" style="position: fixed;right: 5%;bottom: 10%;">
      <img @click="scrollToSection('zhixingld')" style="width: calc(36px + 0.4vw);height: calc(36px + 0.4vw);" src="@/img/icon_hssy_zhiding@2x.png" alt="">
    </div>
    <ckqb ref="inmn" v-if="emsl == 1" @xindfanhui='xindfanhui'></ckqb>
  </div>
</template>

<script>
import { donation_list, period_result } from "@/request/aapi.js";
import { formatTimestamp } from "@/utils/common.js"; // 保留您需要的工具函式
import SkeletonScreen from "./SkeletonScreen/jkhdSkeletonScreen.vue";
import juank from "@/components/jkhd/juankuan.vue";
import ckqb from "@/components/ckqb.vue";
import { EventBus } from "@/views/event-bus.js";

export default {
  components: {
    SkeletonScreen,
    juank,
    ckqb,
  },
  metaInfo() {
    const isDonationPage = this.$route.path.startsWith('/donation');
    const baseUrl = 'https://gddao.com';
    const canonicalUrl = `${baseUrl}${this.$route.fullPath}`;
    const defaultOgImage = `${baseUrl}/logo.png`;

    let pageTitle, pageDescription, pageKeywords, ogType, currentOgImage;

    if (isDonationPage) {
      // 捐款頁的核心標題，App.vue 的 titleTemplate 會自動加上 " | 好事道"
      pageTitle = '支持您關心的公益項目'; // 修改點
      pageDescription = '在好事道平台上瀏覽並支持各類公益捐款項目。您的每一份愛心都將被精準傳達，並見證其帶來的正面影響與改變。'; // 如果要改描述，在這裡改
      pageKeywords = '捐款,公益項目,支持計畫,好事道,愛心捐助,社會公益';
      ogType = 'article';
      currentOgImage = (this.hot && this.hot.image) ? this.hot.image : defaultOgImage;
    } else { // 首頁 (/)
      // 首頁的核心標題，App.vue 的 titleTemplate 會自動加上 " | 好事道"
      pageTitle = '公益數據管理與 ESG 實踐平台'; // 修改點
      pageDescription = '歡迎來到好事道，一個讓企業與個人ESG好事數據可信、透明、可流通、貨幣化的創新平台。加入我們，共創美好未來。'; // 如果要改描述，在這裡改
      pageKeywords = '好事道,公益平台,ESG,企業社會責任,永續發展,數據透明,SDGs';
      ogType = 'website';
      currentOgImage = defaultOgImage;
    }

    // Open Graph 和 Twitter 的標題，我們可以直接使用 pageTitle，因為它現在是核心標題
    // App.vue 的 titleTemplate 僅影響 <title> 標籤，不直接影響 og:title 或 twitter:title
    // 但通常我們希望它們保持一致或 og:title 更具吸引力。
    // 為確保 og:title 和 twitter:title 是完整的，我們可以這樣組合：
    const fullPageTitleForSharing = `${pageTitle} | 好事道`;

    return {
      title: pageTitle, // 這個 title 會被 App.vue 的 titleTemplate 處理成: pageTitle + " | 好事道"
      link: [
        { rel: 'canonical', href: canonicalUrl, vmid: 'canonical' }
      ],
      meta: [
        { vmid: 'description', name: 'description', content: pageDescription },
        { vmid: 'keywords', name: 'keywords', content: pageKeywords },

        { vmid: 'og:title', property: 'og:title', content: fullPageTitleForSharing }, // 使用組合後的完整標題
        { vmid: 'og:description', property: 'og:description', content: pageDescription },
        { vmid: 'og:url', property: 'og:url', content: canonicalUrl },
        { vmid: 'og:type', property: 'og:type', content: ogType },
        { vmid: 'og:image', property: 'og:image', content: currentOgImage },
        { vmid: 'og:image:width', property: 'og:image:width', content: '1200' },
        { vmid: 'og:image:height', property: 'og:image:height', content: '630' },

        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        { vmid: 'twitter:title', name: 'twitter:title', content: fullPageTitleForSharing }, // 使用組合後的完整標題
        { vmid: 'twitter:description', name: 'twitter:description', content: pageDescription },
        { vmid: 'twitter:image', name: 'twitter:image', content: currentOgImage },
      ].filter(Boolean)
    };
  },
  data() {
    return {
      emsl: 0,
      show: 0,
      xasddinfo:{ // 初始化為空對象，避免模板渲染錯誤
        received_amount: 0,
        used_amount: 0,
        donor_num: 0,
      },
      modalShow: false,
      dataLoaded: false,
      isDropdownOpen: false, 
      istoggleDropdownm: false,
      showImage: false, 
      isLoading: false,
      jhuxa: this.$t("全部"),
      tdjhuxa: this.$t("团队类型"),
      items: [ // 保持您現有的結構，或根據API調整
        { name: 1, }, { name: 1, }, { name: 1, }, { name: 1, }, { name: 1, }, { name: 1, },
      ],
      hdlb: [{}, {}, {}, {}, {}],
      donation: [],
      hot: {}, // 初始化 hot 為空對象，避免模板渲染和 metaInfo 中的錯誤
      tkdsj: {},
      remark: [],
      used: [],
      isids: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getDonation_list();
    if (this.$route.query.order_no) {
      this.period_result();
    }
    // setTimeout 改為 nextTick 以確保 DOM 準備好
    this.$nextTick(() => {
      const container = this.$refs.scrollContainer;
      if (container) { // 增加檢查以防 container 未定義
        container.addEventListener("scroll", this.handleScrolls);
      }
      this.checkSidebar();
      EventBus.$on('check-sidebar', this.checkSidebar);
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    // 確保移除事件監聽器，即使 container 可能不存在
    const container = this.$refs.scrollContainer;
    if (container) {
      container.removeEventListener("scroll", this.handleScrolls);
    }
    EventBus.$off('check-sidebar', this.checkSidebar);
  },
  methods: {
    checkSidebar() {
      this.$nextTick(() => {
        const exists = !!this.$refs.leftSidebarBox;
        EventBus.$emit('sidebar-status', exists);
      });
    },
    scrollToSection(sectionId) {
      // this.sectionId = sectionId; // sectionId 似乎未在其他地方使用
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleScrolls() {
      const container = this.$refs.scrollContainer;
      if (!container) return; // 防禦性檢查

      const scrollTop = container.scrollTop;
      const containerHeight = container.clientHeight; // clientHeight 是可見區域高度

      if (scrollTop >= containerHeight) { // 這個條件可能需要調整，取決於您想何時顯示按鈕
        this.showImage = true; 
      } else {
        this.showImage = false;
      }
    },
    zjsyqk(e) {
      this.$router.push({
        name: "zzsy",
        params: {
          // isT: 2, // isT 似乎是舊的參數，根據您的路由定義，可能不需要
          zjsy: e,
          judge: "1", // judge 參數的用途需要確認
        },
      });
    },
    handleScroll() {
      const scrollTop = window.scrollY; 
      const clientHeight = window.innerHeight; 
      const scrollHeight = document.documentElement.scrollHeight; 
      if (scrollTop > clientHeight) { // 當滾動超過一屏時顯示
        this.showImage = true;
      } else {
        this.showImage = false;
      }
      // 判斷是否滾動到底部（留一些緩衝）
      if (scrollTop + clientHeight >= scrollHeight - 100) { 
        if (this.$refs.fczdf && typeof this.$refs.fczdf.gundong === 'function') { // 確保子組件和方法存在
          this.$refs.fczdf.gundong();
        }
      }
    },
    timeFilter(stringTime) {
      // 確保 stringTime 存在且是數字，避免 NaN
      if (stringTime && !isNaN(stringTime)) {
        return formatTimestamp(Number(stringTime) * 1000);
      }
      return ''; // 或者返回一個預設值，如 '日期未知'
    },
    async period_result() {
      try { // 添加 try-catch 處理 API 錯誤
        const { data } = await period_result({
          order_no: this.$route.query.order_no,
        });
        if (data && data.info) { // 檢查 data.info 是否存在
          this.tkdsj = data.info;
          this.modalShow = true;
        } else {
          console.warn('period_result API 未返回有效的 info 數據');
        }
      } catch (error) {
        console.error('獲取 period_result 失敗:', error);
      }
    },
    chakanxq(e) {
      if (this.$refs.fczdf && typeof this.$refs.fczdf.smdckxq === 'function') {
        this.$refs.fczdf.smdckxq(e);
      }
    },
    getDonation_list() {
      donation_list().then((res) => {
        if (res.code == 200 && res.data) { // 確保 res.data 存在
          this.xasddinfo = { // 安全地賦值，提供預設值
             received_amount: res.data.received_amount || 0,
             used_amount: res.data.used_amount || 0,
             donor_num: res.data.donor_num || 0,
          };
          this.dataLoaded = true;
          this.donation = res.data.donation || [];
          this.hot = res.data.hot || {}; // 確保 hot 是對象
          this.remark = res.data.remark || [];
          this.used = res.data.used || [];
          
          // 數據獲取後，vue-meta 會自動檢測變化並更新 meta
          // 如果 metaInfo 依賴於 this.hot.image，且 this.hot 在此更新，
          // vue-meta 將使用新的 this.hot.image
        } else {
          // 處理 API 返回錯誤或數據格式不正確的情況
          this.dataLoaded = true; // 即使失敗也結束骨架屏，可以顯示錯誤提示
          console.warn('getDonation_list API 請求失敗或數據格式不正確:', res);
        }
      }).catch(error => {
        this.dataLoaded = true; // API 請求異常也結束骨架屏
        console.error('獲取 getDonation_list 失敗:', error);
      });
    },
    funs(e) { // e 參數未使用
      this.$router.push("/members/point-logs");
    },
    xindfanhui(e) {
      this.emsl = e;
    },
    emslfun(e) {
      if (e == 1) {
        this.$nextTick(() => { // 使用 nextTick 確保 $refs 可用
          if (this.$refs.inmn && typeof this.$refs.inmn.getInfo === 'function') {
            this.$refs.inmn.getInfo();
          }
        });
      }
      this.emsl = e;
    },
    fczff(a) { // a 參數未使用
      if (this.hot && this.hot.id) { // 確保 this.hot.id 存在
        this.isids = this.hot.id;
        this.$router.push({
          // path: "/donation/" + this.hot.id, // 使用 path 或 name
          name: 'ckxq', // 假設 ckxq 是捐款詳情的路由名稱
          params: {
            // isT: 1, // isT 參數的用途不明，如果不需要可以移除
            ckxq: this.hot.id // 假設路由參數是 ckxq
          },
        });
      } else {
        console.warn('無法跳轉 fczff，this.hot.id 未定義');
      }
    },
    custom(e) {
      this.show = e;
    },
    tiaozhuan() { // 這個方法似乎是跳轉到一個固定的團體詳情，如果不再需要可以考慮移除
      this.$router.push("/groups/groupdetails");
    },
    xuanz(e) {
      this.jhuxa = e;
      this.isDropdownOpen = false;
    },
    tdxuanz(e) {
      this.tdjhuxa = e;
      this.istoggleDropdownm = false;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    toggleDropdownm() {
      this.istoggleDropdownm = !this.istoggleDropdownm;
    },
  },
};
</script>
<style >
.custom-modal-widths .modal-dialog {
  position: relative;
  max-width: 50% !important;
  margin: auto;
  pointer-events: none;
}
@media screen and (max-width: 995px) {
  .custom-modal-widths .modal-dialog {
    position: relative;
    max-width: 90% !important;
    margin: auto;
    pointer-events: none;
  }
  .sjbtop{
    padding-top: 1rem !important;
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 995px) {
  .sjyinc {
    display: block !important;
  }
  .yinc {
    display: none !important;
  }
  .heggs {
    margin-top: 1rem !important;
  }
  .heggs {
    height: 79vh !important;
  }
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .sjbxxzt {
    font-size: calc(9px + 0.4vw) !important;
  }
}
@media screen and (max-width: 1200px) {
  .phoneNone{
    display: none!important;;
  }
}
.phoneNone{
  display:block;
}
.heggs {
  height: 89.5vh;
}
.sjyinc {
  display: none;
}
.annys {
  font-size: calc(6px + 0.4vw);
  background: #ffd672;
  width: 144px;
  margin: auto;
  border: none;
}

.inppt {
  background: white;
  border: none;
  border-radius: 13px;
  font-size: calc(7px + 0.4vw);
  padding-top: 22px;
  padding-bottom: 22px;
}

.zhankai {
  background: #ffebd2;
  text-align: center;
  border-radius: 12px 12px 12px 12px;
  border: none;
  font-weight: 400;
  font-size: calc(6px + 0.4vw);
  color: #1a1a1a;
}

.form-control {
  height: calc(15px + 0.5vw) !important;
}

.sxbj {
  padding-top: calc(15px + 0.5vw);
  padding-bottom: calc(15px + 0.5vw);
}

.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.ckq:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  font-weight: 800;
}

.sbxfbd:hover {
  transform: scale(1.1);
}
.dropdown-menu {
  min-width: calc(130px + 0.5vw) !important;
  font-size: calc(8px + 0.4vw) !important;
}
.xlcd {
  display: block;
  background: #ffebd2;
  border: none;
}
.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
/* 隐藏水平滚动条 */
.lieb::-webkit-scrollbar {
  display: none;
}

.ellipsis-multiline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dydpd {
  padding-top: calc(7px + 0.4vw);
  padding-bottom: calc(7px + 0.4vw);
  padding-left: calc(10px + 0.5vw);
  padding-right: calc(10px + 0.5vw);
}
.dropdown-item:hover {
  background-color: #ffebd2;
  color: #b66d00;
  border-radius: 12px;
}
.dropdown-item{
  text-align: left;
}
.tkd {
  font-size: calc(10px + 0.4vw);
  font-weight: 700;
}
.tkx {
  font-size: calc(7px + 0.4vw);
  color: #666666;
}
.xiaod {
  font-size: calc(8px + 0.4vw);
  font-weight: 700;
  width: 25%;
}
.bdxian {
  height: 1px;
  width: 100%;
  background: #1a1a1a;
}
</style>